<template>
	<footer class="py-3 my-4 d-none d-md-flex justify-content-center">
		<p class="text-center text-muted">&copy; {{ new Date().getFullYear() }} Omni Hotelier - A Revolutionary Cloud Base Hospitality System - All rights reserved.</p>
	</footer>
</template>
